var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-avatar',{staticClass:"avatar",attrs:{"size":_vm.size,"src":_vm.src,"shape":_vm.shape,"placeholder":_vm.placeholder,"fit":"cover"},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('img',{attrs:{"src":require("./img/avatar.png"),"alt":""}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }